<template>
  <div class="portlet light">
    <div class="portlet-body">
      <div>
        <div>
          <div class="card">
            <div class="card-body">
              <h4>Escalation Path and SLA's</h4>
              <a
                href="https://dealerinspire.atlassian.net/wiki/spaces/PO/pages/401997881/Escalation+Path+and+SLA+s"
                target="_blank"
              >https://dealerinspire.atlassian.net/wiki/spaces/PO/pages/401997881/Escalation+Path+and+SLA+s</a>
              <p>
                <br>
              </p>

              <table class="table table-hover table-light">
                <thead>
                  <tr class="uppercase">
                    <th>Request Type</th>
                    <th>Product Team</th>
                    <th>Jira Ticket</th>
                    <th class="text-center">Date Requested</th>
                    <th class="text-center">Estimated Delivery</th>
                    <th class="text-center">Business Value</th>
                    <th class="text-center">Status</th>
                    <th class="text-right">Product Owner</th>
                  </tr>
                </thead>

                <tbody v-if="isLoading">
                  <tr>
                    <td colspan="7">
                      <Loading height="30"></Loading>
                    </td>
                  </tr>
                </tbody>

                <tbody
                  v-else-if="requests.length > 0"
                  v-for="row in this.requests"
                  v-bind:key="row.jiraTicket"
                >
                  <tr>
                    <td>{{row.issueType}}</td>
                    <td>{{row.productTeam}}</td>
                    <td>
                      <a :href="getJiraUrl(row.jiraTicket)" target="_blank">{{row.jiraTicket}}</a>
                      {{row.description}}
                    </td>
                    <td class="text-center">{{getFormattedDate(row.dateRequested)}}</td>
                    <td class="text-center">{{getFormattedDate(row.estimatedDelivery)}}</td>
                    <td class="text-center">{{row.businessValue}}</td>
                    <td class="text-center">{{getFormattedStatus(row.status, row.resolution)}}</td>
                    <td class="text-right">{{row.productOwner}}</td>
                  </tr>
                </tbody>

                <tbody v-else>
                  <tr>
                    <td colspan="7">
                      <br>No requests found for you
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Loading from "../../components/Loading";

export default {
  name: "EnhancementStatus",
  props: ["profile", "jira"],
  components: { Loading },
  created() {
    axios
      // .get("http://localhost:3001/tickets/" + this.profile.email)
      .get(
        "https://fwtyoowisa.execute-api.us-east-1.amazonaws.com/dev/tickets/" +
          this.profile.email
      )
      .then(response => {
        this.processJiraResponse(response.data);
        this.isLoading = false;
      });
  },
  mounted() {
    axios
      // .get("http://localhost:3001/tickets/" + this.profile.email)
      .get(
        "https://fwtyoowisa.execute-api.us-east-1.amazonaws.com/dev/tickets/" +
          this.profile.email
      )
      .then(response => {
        this.processJiraResponse(response.data);
        this.isLoading = false;
      });
  },
  methods: {
    getJiraUrl(ticket) {
      return "https://dealerinspire.atlassian.net/browse/" + ticket;
    },
    processJiraResponse(response) {
      this.requests = response.map(obj => {
        return {
          issueType: obj.issuetype,
          productTeam: this.getJiraProjectName(obj.project),
          jiraTicket: obj.key,
          description: obj.summary,
          dateRequested: obj.created,
          estimatedDelivery: obj.duedate,
          businessValue: obj.businessValue,
          status: obj.status,
          resolution: obj.resolution,
          productOwner: this.getProductOwnerName(obj.project)
        };
      });
    },
    getJiraProjectName(project) {
      return this.jira.projects[project]
        ? this.jira.projects[project].name
        : "Unknown Project";
    },
    getProductOwnerName(project) {
      return this.jira.projects[project]
        ? this.jira.projects[project].productOwner
        : "Unknown Product Owner";
    },
    getFormattedDate(value) {
      if (value == null) {
        return value;
      }

      return moment(String(value)).format("MM/DD/YYYY");
    },
    getFormattedStatus(status, resolution) {
      return status == "Done" &&
        this.getResolutionName(resolution).length > 0 &&
        this.getResolutionName(resolution) != "Done"
        ? "Done - " + this.getResolutionName(resolution)
        : status;
    },
    getResolutionName(resoution) {
      return resoution != null ? resoution.name : "";
    }
  },
  data() {
    return {
      isLoading: true,
      requests: []
    };
  }
};
</script>
